<template>
  <modal
    :show.sync="showChangeModal"
    modalContentClasses=""
    modalClasses="modal-alert"
    type="mini"
    @close="closeChangePartner(false)"
    no-close-on-backdrop
  >
    <div
      class="col-12 pt-4 pb-2"
      :class="{ 'is-invalid': $v.changeType.$error }"
    >
      <div class="text-center">
        <img
          src="~rhomtrip_assets/src/img/icons/alerts/question.png"
          alt="question"
          class="icon-modal"
        />
        <h2 class="modal-title mb-1">
          Partner Change
        </h2>
      </div>
      <p>How do you want to proceed with the change?</p>

      <b-form-radio-group
        id="radio-approval"
        v-model="$v.changeType.$model"
        aria-describedby="ariaDescribedby"
        name="radio-optionapproval"
        stacked
        size="md"
      >
        <b-form-radio value="changeAgency" tabindex="15"
          >Change Agency</b-form-radio
        >
        <b-form-radio value="convertToAgency">Convert to Agency</b-form-radio>
      </b-form-radio-group>

      <small class="invalid-feedback text-center" v-if="$v.changeType.$error"
        >Select an option</small
      >

      <div class="col-12 mt-3" v-if="changeType === 'changeAgency'">
        <WSelect
          v-bind:class="{
            'invalid-feedback': $v.agencyId.$error
          }"
          v-model="$v.agencyId.$model"
          label="Agency to associate"
          placeholder="Enter an Agency Name"
          id="agency_name"
          name="agency_name"
          tabindex="3"
          remote
          filterable
          reserve-keyword
          clearable
          :error="
            !$v.agencyId.minLength || $v.agencyId.$error
              ? `Select an Agency to associate `
              : ''
          "
        >
          <el-option
            v-for="(agency, index) in agencies"
            :value="agency._id"
            :label="agency.company_name"
            :key="index"
          ></el-option>
        </WSelect>
      </div>

      <div class="col-12 mt-3" v-if="changeType === 'convertToAgency'">
        <base-input
          v-model.trim="$v.agencyName.$model"
          label="Agency Name"
          placeholder="Agency Name"
          id="bussiness_name"
          name="bussiness_name"
          maxlength="45"
          :error="
            !$v.agencyName.minLength || $v.agencyName.$error
              ? `Enter from ${$v.agencyName.$params.minLength.min} to ${$v.agencyName.$params.maxLength.max} characters.`
              : ''
          "
        />
      </div>
    </div>
    <div
      class="border-top pt-3 text-center col-12 d-flex justify-content-around"
    >
      <base-button
        type="outline-neutral"
        class="min-button "
        @click="closeChangePartner(false)"
        >Close</base-button
      >

      <base-button
        type="primary"
        class="min-button ml-auto"
        @click.stop="changePartner(partnerId)"
        >Accept</base-button
      >
    </div>
  </modal>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import { PartnersAPI } from "../../../core/api";
import {
  required,
  minLength,
  requiredIf,
  maxLength
} from "vuelidate/lib/validators";
import WSelect from "@/components/Select";
WSelect.computed.readonly = function() {
  const isIE = !this.$isServer && !Number.isNaN(Number(document.documentMode));
  return (
    !this.filterable ||
    this.multiple ||
    (!isIE && !this.visible && !this.remote)
  );
};
export default {
  name: "PartnerChange",
  props: {
    show: {
      type: Boolean,
      default: false,
      description: "(closeable)"
    },
    partnerId: {
      type: String,
      default: () => null,
      description: "(Reservation Id)"
    },
    agencies: {
      type: Array,
      default: () => [],
      description: "(agencies)"
    }
  },
  data() {
    return {
      changeType: "",
      agencyId: "",
      showChangeModal: true,
      agencyName: ""
    };
  },
  async created() {
    this.showChangeModal = this.show;
    this.resetData();
  },
  watch: {
    show: {
      handler: function(current, old) {
        this.showChangeModal = current;
        this.$v.$reset();
      },
      deep: true
    }
  },
  methods: {
    async changePartner(partnerId) {
      if (!this.$v.$invalid) {
        if (this.changeType === "changeAgency") {
          await this.reassignAgency(partnerId, this.agencyId);
        } else if (this.changeType === "convertToAgency") {
          await this.changeAgentToAgency(partnerId, this.agencyName);
        }
      } else {
        this.$v.$touch();
        this.$notify({
          type: "warning",
          title: "Important!",
          message: "Please complete the required attributes",
          icon: "flaticon-warning-1"
        });
      }
    },
    closeChangePartner(status) {
      this.showChangeModal = status;
      this.resetData();
      this.$emit("closeChangeModal", status);
    },
    resetData() {
      this.changeType = "";
      this.agencyId = "";
      this.agencyName = "";
      this.$v.$reset();
    },
    partnerChangedEvent(status) {
      this.$emit("partnerChanged", status);
      this.closeChangePartner(false);
    },
    async changeAgentToAgency(partnerId, agencyName) {
      try {
        let { data } = await PartnersAPI.changeAgentToAgency(
          partnerId,
          agencyName,
          this.sesion.token
        );
        if (data.status) {
          this.$notify({
            type: "success",
            title: "Success!",
            message: "The changes has been saved",
            icon: "flaticon-check-3"
          });
          this.partnerChangedEvent(true);
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message:
              "The changes couldn't be save, check the Partner data and try again",
            icon: "flaticon-remove"
          });
          this.partnerChangedEvent(false);
        }
      } catch (error) {
        this.$notify({
          type: "danger",
          title: "Error!",
          message:
            "The changes couldn't be save, check the Partner data and try again",
          icon: "flaticon-remove"
        });
        this.partnerChangedEvent(false);
      }
    },
    async reassignAgency(partnerId, agencyId) {
      try {
        let { data } = await PartnersAPI.reassignAgency(
          partnerId,
          agencyId,
          this.sesion.token
        );
        if (data.status) {
          this.$notify({
            type: "success",
            title: "Success!",
            message: "The changes has been saved",
            icon: "flaticon-check-3"
          });
          this.partnerChangedEvent(true);
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message:
              "The changes couldn't be save, check the Partner data and try again",
            icon: "flaticon-remove"
          });
          this.partnerChangedEvent(false);
        }
      } catch (error) {
        this.$notify({
          type: "danger",
          title: "Error!",
          message:
            "The changes couldn't be save, check the Partner data and try again",
          icon: "flaticon-remove"
        });
        this.partnerChangedEvent(false);
      }
    },
    ...mapMutations(["setLoad"])
  },
  computed: {
    ...mapGetters(["sesion"])
  },
  components: {
    WSelect
  },
  validations: {
    changeType: {
      required
    },
    agencyId: {
      minLength: minLength(2),
      required: requiredIf(function(value) {
        return this.changeType === "changeAgency";
      })
    },
    agencyName: {
      minLength: minLength(3),
      maxLength: maxLength(45),
      required: requiredIf(function(value) {
        return this.changeType === "convertToAgency";
      })
    }
  }
};
</script>
